module.exports = __webpack_public_path__ + "img/ak-logo-badge--solid-dark.bd1c1488.svg";